var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dinput-checkbox"},[_c('sl-checkbox',{model:{value:(_vm.fieldValue.valor),callback:function ($$v) {_vm.$set(_vm.fieldValue, "valor", $$v)},expression:"fieldValue.valor"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }